import { PageHeader } from "../../components/shared/PageHeader";
import { Badge } from "../../components/shared/Badge";
import { Eye } from "lucide-react";

const ROLES = [
  {
    id: "1", name: "Enterprise Admin", description: "Full enterprise management, including all ConfigIQ activity",
    modules: ["ConfigIQ", "Admin"], users: 1, scope: "Enterprise", type: "system",
  },
  {
    id: "2", name: "ConfigIQ User", description: "Create tasks, generate files, and view your own history",
    modules: ["ConfigIQ"], users: 12, scope: "Enterprise", type: "system",
  },
  {
    id: "3", name: "Read Only", description: "View access. Cannot create, edit, or generate",
    modules: ["ConfigIQ"], users: 5, scope: "Enterprise", type: "system",
  },
];

export function EnterpriseRolesPage() {
  return (
    <div className="space-y-5">
      <PageHeader
        title="Roles"
        subtitle="Roles are defined by your platform administrator. Enterprise admins can assign them to users."
      />

      <div className="bg-white border border-ds-border rounded-card shadow-card overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-ds-border bg-ds-bg">
              <th className="text-left text-xs font-medium text-ds-text-muted uppercase tracking-wide px-5 py-3">Role</th>
              <th className="text-left text-xs font-medium text-ds-text-muted uppercase tracking-wide px-5 py-3">Module access</th>
              <th className="text-left text-xs font-medium text-ds-text-muted uppercase tracking-wide px-5 py-3">Users</th>
              <th className="text-left text-xs font-medium text-ds-text-muted uppercase tracking-wide px-5 py-3">Type</th>
              <th className="px-5 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-ds-border">
            {ROLES.map((role) => (
              <tr key={role.id} className="hover:bg-ds-bg/50">
                <td className="px-5 py-3.5">
                  <p className="text-sm font-medium text-ds-text">{role.name}</p>
                  <p className="text-xs text-ds-text-muted mt-0.5">{role.description}</p>
                </td>
                <td className="px-5 py-3.5">
                  <div className="flex flex-wrap gap-1">
                    {role.modules.map((m) => <Badge key={m} variant="blue">{m}</Badge>)}
                  </div>
                </td>
                <td className="px-5 py-3.5 text-sm text-ds-text">{role.users}</td>
                <td className="px-5 py-3.5">
                  <Badge variant={role.type === "system" ? "gray" : "purple"}>
                    {role.type === "system" ? "System" : "Custom"}
                  </Badge>
                </td>
                <td className="px-5 py-3.5">
                  <button className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 text-xs font-medium">
                    <Eye className="w-3 h-3" /> View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-xs text-ds-text-muted">
        To create or modify roles, contact your platform administrator.
      </p>
    </div>
  );
}
